import { geraPdfReceituarioSimples } from './geraPdfReceituarioSimples'

/**
 * Gera o receituário de controle especial no navegador. O motor de
 * composição é o mesmo da receita simples para preservar HTML, cores,
 * negrito, itálico e listas no conteúdo da prescrição.
 */
export const geraPdfReceituarioEspecial = (dados) =>
  geraPdfReceituarioSimples({
    ...dados,
    especial: true,
  })
